import React from 'react';
import './TechCards.css';

const cards = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12h2.2l1.3-4 1.6 8 1.6-8 1.6 8 1.6-8 1.6 8 1.3-4H22" />
      </svg>
    ),
    title: 'Advanced\nSuspension',
    text: 'Superior control on every terrain.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2v20M2 12h20M5 5l14 14M19 5 5 19" />
        <path d="M12 5 9.5 7.5M12 5l2.5 2.5M12 19l-2.5-2.5M12 19l2.5-2.5M5 12l2.5-2.5M5 12l2.5 2.5M19 12l-2.5-2.5M19 12l-2.5 2.5" />
      </svg>
    ),
    title: 'Extreme Climate\nTested',
    text: 'Performs from -30°C to 60°C.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2.5 5 5.2v5c0 4.4 3 7.5 7 9.3 4-1.8 7-4.9 7-9.3v-5L12 2.5Z" />
        <path d="m8.8 11.8 2.2 2.2 4-4.4" />
      </svg>
    ),
    title: 'Long-Life\nEngineering',
    text: 'Corrosion-resistant materials & coatings.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9.5" />
        <path d="M5 12h2.5l1.5-4 2.5 8 2-6 1.3 2H19" />
      </svg>
    ),
    title: 'Smart\nDiagnostics',
    text: 'Real-time data for peak performance.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7h9M17 7h3" />
        <circle cx="15" cy="7" r="2" />
        <path d="M4 17h3M11 17h9" />
        <circle cx="9" cy="17" r="2" />
      </svg>
    ),
    title: 'Fully\nCustomisable',
    text: 'Built around your needs and your style.',
  },
];

function TechCards() {
  return (
    <section className="techcards">
      <div className="techcards__inner">
        {cards.map((c) => (
          <div className="techcard" key={c.title}>
            <span className="techcard__icon">{c.icon}</span>
            <div className="techcard__text">
              <h3 className="techcard__title">
                {c.title.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i === 0 && <br />}
                  </React.Fragment>
                ))}
              </h3>
              <p className="techcard__desc">{c.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TechCards;
